import { head } from 'lodash';

import { Item, Image, ImageState } from '@admin/schema';

type ImageFragment = Pick<Image, 'id' | 'source' | 'state'>;

type ItemFragment = Pick<Item, 'id' | 'hero'> & {
  images: ImageFragment[];
};

export const hero = (item: ItemFragment): ImageFragment | undefined => {
  const images = item.images;
  const hero = item.hero;
  const image = images.length > 0 && typeof hero === 'number' && hero < images.length ? images[hero] : head(images);
  if (image?.state !== ImageState.Uploaded) return;

  return image;
};
